import Indicator, { IndicatorType } from '../../types/Indicator'

const Minor: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'minor',
  label: 'Minor',
  fields: ['grayMinor', 'blackMinor'],
}

export default Minor
